module.exports = __webpack_public_path__ + "img/1.13e77071.png";